<template>
  <div v-show="products?.length || loading" :class="{ 'pb-3 lg:pb-6': !isSearchHub }">
    <div
      v-if="title"
      class="flex items-center pb-2 between"
      :class="[titleClass, isSearchHub ? 'pt-2' : 'pt-6 lg:pb-4']"
    >
      <h2 v-style:c="titleColor" :class="isSearchHub ? 'subtitle-5 c-brand-1' : titleStyle">
        <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
        <span v-else>{{ title }}</span>
      </h2>
      <vf-carousel-controls :carousel-ref :class="{ 'lg:hidden': isSearchHub }" :variant="backgroundType" />
    </div>
    <vf-carousel-elevate
      ref="carouselRef"
      align="start"
      class-container="lg:-mr-1"
      :class-controls="
        [
          'b b-white rounded-full bg-white bg-op-80 flex shadow-sm center backdrop-blur-xs',
          isSearchHub ? 'h-8 w-8 -mt-8 mx-2' : 'h-11 w-11 mx-6',
        ].join(' ')"
      loop
      :show-arrows="$viewport.lg && (!title || isSearchHub)"
      :show-arrows-on-hover-only="$viewport.lg && (!title || isSearchHub)"
      :size-controls="isSearchHub ? 'sm' : 'md'"
      :slides-to-scroll="!$viewport.md ? 'auto' : (variant === '6-cards' ? 6 : 3)"
    >
      <template v-if="!products?.length">
        <div
          v-for="i in 6"
          :key="i"
          v-style:w="variantStyleMap[variantOverride || variant]"
          class="pr-1 children:skeleton"
        >
          <div style="aspect-ratio: 0.72" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(product, i) in products"
          :key="product.id"
          v-style:w="variantStyleMap[variantOverride || variant]"
          :class="{ 'pr-1': !isSearchHub }"
        >
          <product-card-recommended
            :currency
            v-bind="product"
            :gtm-config="{
              placement: isSearchHub ? extractPageType('/searchhub') : getPageInfo(route, {})[0],
              title,
            }"
            :quickshop
            :variant
            @product-click="$emit('product-click', product, i + 1)"
          />
        </div>
      </template>
    </vf-carousel-elevate>
  </div>
</template>

<script lang="ts" setup>
import type { LayoutVariant, Props } from '#types/components/cms/recommendation-carousel'
import { getPageInfo } from '#commerce/gtm/page'

const {
  backgroundType,
  quickshop = true,
  title,
  titleStyle = 'body-3',
  variant = '6-cards'
} = defineProps<Props>()

defineEmits<{
  'product-click': [product: any, position: number]
}>()

const { variantStyleMap } = useAppConfig().components.cms.bloomreachRecommendations

const carouselRef = ref()
const route = useRoute()

const variantOverride = inject('variantOverride', undefined) as LayoutVariant | undefined

const isSearchHub = computed(() => (variantOverride || variant) === 'search-hub')
</script>
